import { jsx as _jsx } from "react/jsx-runtime";
import { RenderingModeCheckbox } from './RenderingModeCheckbox';
export const RenderingModeHeader = ({ gameIndex }) => {
    const width = '100%';
    const height = '8%';
    return (_jsx("div", { style: { display: 'flex', flexDirection: 'row', padding: '0 ' + '24px', height, width, zIndex: 5, position: 'fixed', boxSizing: 'border-box' }, children: _jsx(RenderingModeCheckbox, { gameIndex: gameIndex }, 'Contact3DRenderingModeCheckbox') }));
};
//# sourceMappingURL=RenderingModeHeader.js.map